import styled from 'styled-components';

const CustomSmallCardStyle = styled.div`
  height: 72px;
  width: 372px;
  padding: 8px 24px 0 24px;
  border-radius: 10px;
  background: #f2f4f5;
  margin: 1rem;

  .custom-card-style-title {
    margin-bottom: 5px;

    span {
      font-size: 16px;
      font-family: UbuntuMedium, sans-serif;
      color: #1d2228;
    }
  }

  .custom-card-style-description {
    p {
      font-size: 25px;
      color: #f72717;
      font-family: UbuntuMedium, sans-serif;
      margin: 0;
    }
  }

  @media (max-width: 1199.98px) {
    height: auto;
    width: auto;
    padding: 8px 24px 8px 24px;
    border-radius: 10px;
    background: #f2f4f5;
    margin: 1rem;

    .custom-card-style-title {
      span {
        font-size: 14px;
        font-family: UbuntuBold, sans-serif;
        color: #3f4957;
      }
    }

    .custom-card-style-description {
      p {
        font-size: 18px;
        color: #f72717;
        font-family: UbuntuMedium, sans-serif;
        margin: 0;
      }
    }
  }
`;

export const CustomSmallCard = ({ title, description, ...props }) => {
  return (
    <CustomSmallCardStyle {...props} className="custom-card-style">
      <div className="custom-card-style-title">
        <span>{title}</span>
      </div>
      <div className="custom-card-style-description">
        <p>{description}</p>
      </div>
    </CustomSmallCardStyle>
  );
};
